import { render, staticRenderFns } from "./archive-detail.vue?vue&type=template&id=fd441848&scoped=true"
import script from "./archive-detail.vue?vue&type=script&lang=js"
export * from "./archive-detail.vue?vue&type=script&lang=js"
import style0 from "./archive-detail.vue?vue&type=style&index=0&id=fd441848&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd441848",
  null
  
)

export default component.exports